var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.781 3.817A.5.5 0 0 1 9.464 4 4 4 0 0 1 8 9.464a4 4 0 0 1-1.8.53l1.154 1.152-.708.707L4.293 9.5l2.353-2.354.708.708-1.14 1.137A3 3 0 0 0 9 6a3 3 0 0 0-.402-1.5.5.5 0 0 1 .183-.683M7.707 2.5 5.354 4.854l-.708-.708 1.138-1.138A3.002 3.002 0 0 0 3.402 7.5a.5.5 0 0 1-.866.5A4 4 0 0 1 5.8 2.006L4.646.854l.708-.708z"
  })));
};
export default SvgRefresh;